module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approval-list-container"
  }, [(_vm.isBusy) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "border-0 shadow-sm",
    staticStyle: {
      "border-radius": "8px",
      "overflow": "hidden"
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": "",
      "pills": ""
    },
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "All"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Approved"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Rejected"
    }
  })], 1), _vm._v(" "), _c('b-card-header', {
    staticClass: "bg-white border-bottom p-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-0"
  }, [_c('h4', {
    staticClass: "mb-0 text-primary font-weight-bold"
  }, [_c('i', {
    staticClass: "fa fa-ship mr-2"
  }), _vm._v("SLINE DISPUTE DASHBOARD\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-input-group', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('b-input-group-prepend', {
    staticClass: "bg-light border-right-0",
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search text-muted"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "border-left-0 bg-light",
    attrs: {
      "placeholder": "Search Job No, Inv No..."
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.exportLoading
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" " + _vm._s(_vm.exportLoading ? '...' : 'Export') + "\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.getData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh\n          ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.filter-collapse",
      modifiers: {
        "filter-collapse": true
      }
    }],
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filters\n          ")])], 1)]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-3",
    attrs: {
      "id": "filter-collapse"
    },
    model: {
      value: (_vm.filtersVisible),
      callback: function($$v) {
        _vm.filtersVisible = $$v
      },
      expression: "filtersVisible"
    }
  }, [_c('b-card', {
    staticClass: "bg-light border-0"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    staticClass: "w-100",
    attrs: {
      "startDate": _vm.dateRange.startDate,
      "endDate": _vm.dateRange.endDate
    },
    on: {
      "update": _vm.onFilterChange
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return [_c('div', {
          staticClass: "d-flex align-items-center form-control"
        }, [_c('i', {
          staticClass: "fa fa-calendar mr-2 text-muted"
        }), _vm._v(" "), (picker.startDate && picker.endDate) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.moment(picker.startDate).format('DD/MM/YYYY')) + " - " + _vm._s(_vm.moment(picker.endDate).format('DD/MM/YYYY')) + "\n                    ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Select Date Range")])])]
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Job Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.jobTypeOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "All"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.jobType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "jobType", $$v)
      },
      expression: "filters.jobType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Transport")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "All"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.transportType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "transportType", $$v)
      },
      expression: "filters.transportType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex align-items-end mb-3",
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "block": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n                Reset\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('b-table', {
    staticClass: "mb-0 custom-table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "responsive": "",
      "show-empty": "",
      "hover": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "invoiceDetails",
      fn: function(row) {
        return [(row.item.invoice_details) ? _c('div', {
          staticClass: "cell-content"
        }, [_c('div', [_c('strong', [_vm._v("Inv No:")]), _vm._v(" "), (row.item.invoice_details.invUpload) ? _c('a', {
          staticClass: "text-primary font-weight-bold",
          attrs: {
            "href": String(row.item.invoice_details.invUpload).startsWith('http') ? row.item.invoice_details.invUpload : ("" + _vm.docURL + (row.item.jobNo) + "/" + (row.item.invoice_details.invUpload)),
            "target": "_blank"
          }
        }, [_vm._v("\n                " + _vm._s(row.item.invoice_details.invNo) + "\n              ")]) : _c('span', [_vm._v(_vm._s(row.item.invoice_details.invNo))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Inv Date:")]), _vm._v(" " + _vm._s(row.item.invoice_details.invDate))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Pay Req Date:")]), _vm._v(" " + _vm._s(row.item.invoice_details.paymentReqDate))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Inv Category:")]), _vm._v(" " + _vm._s(row.item.invoice_details.invCategory))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Inv Type:")]), _vm._v(" " + _vm._s(row.item.invoice_details.invType))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Dispute Reason:")]), _vm._v(" " + _vm._s(row.item.invoice_details.disputeReason))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Inv Amount:")]), _vm._v(" " + _vm._s(row.item.invoice_details.billingAmount))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Billing Amount:")]), _vm._v(" "), _c('span', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(row.item.invoice_details.resolvedAmount))])]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Dispute Status:")]), _vm._v(" " + _vm._s(row.item.invoice_details.status))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("To be Billed:")]), _vm._v(" " + _vm._s(row.item.invoice_details.category))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Remark:")]), _vm._v(" " + _vm._s(row.item.invoice_details.remark))])]) : _c('div', {
          staticClass: "text-muted italic small"
        }, [_vm._v("No invoice data")])]
      }
    }, {
      key: "jobDetails",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [_c('div', [_c('strong', [_vm._v("Job No:")]), _vm._v(" "), _c('span', {
          staticClass: "text-primary font-weight-bold"
        }, [_vm._v(_vm._s(row.item.jobNo))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Job Date:")]), _vm._v(" "), _c('span', {
          staticClass: "text-primary font-weight-bold"
        }, [_vm._v(_vm._s(row.item.jobDate))])]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(row.item.rsa_job_type) + " / " + _vm._s(row.item.rsa_transport_type))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Mode:")]), _vm._v(" " + _vm._s(row.item.mode))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Vessel:")]), _vm._v(" " + _vm._s(row.item.vesselVoyage))])])]
      }
    }, {
      key: "locDetails",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content small"
        }, [_c('div', [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row.item.por))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row.item.pol))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row.item.pod))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row.item.fpod))])])]
      }
    }, {
      key: "otherDetails",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content small"
        }, [_c('div', [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row.item.clientName))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("SLine:")]), _vm._v(" " + _vm._s(row.item.shippingLine))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Vessel / Voy:")]), _vm._v(" " + _vm._s(row.item.vessel) + " / " + _vm._s(row.item.voyage))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("MBL / HBL:")]), _vm._v(" " + _vm._s(row.item.mblNo) + " / " + _vm._s(row.item.hblNo))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("SOB Date:")]), _vm._v(" " + _vm._s(row.item.sobDate))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("MBL Date / Rel:")]), _vm._v(" " + _vm._s(row.item.mblDate) + " / " + _vm._s(row.item.mblReleaseDate))])])]
      }
    }, {
      key: "people",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [_c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("Req:")]), _vm._v(" " + _vm._s(row.item.requesterName))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("App:")]), _vm._v(" " + _vm._s(row.item.approverName || 'Pending Assignment'))])])]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('b-badge', {
          staticClass: "px-2 py-1",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.rsa_approval_status)
          }
        }, [_vm._v("\n              " + _vm._s(row.item.rsa_approval_status) + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "text-muted extra-small mt-1"
        }, [_vm._v(_vm._s(row.item.rsa_created_at_fmt))])], 1)]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "info",
            "title": "View Job Details"
          },
          on: {
            "click": function($event) {
              _vm.viewDetails(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), (row.item.rsa_approval_status === 'PENDING') ? [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.confirmAction(row.item, 'APPROVE')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.confirmAction(row.item, 'REJECT')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])] : _vm._e()], 2)]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-5"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x mb-3"
  }), _vm._v(" "), _c('p', [_vm._v("No records found.")])])])], 2)], 1), _vm._v(" "), _c('b-card-footer', {
    staticClass: "bg-white border-top py-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Showing " + _vm._s(_vm.items.length > 0 ? (_vm.currentPage - 1) * _vm.perPage + 1 : 0) + " to " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalRows)) + " of " + _vm._s(_vm.totalRows) + " entries\n        ")]), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0 custom-pagination",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "pills": ""
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "action-confirm-modal",
    attrs: {
      "id": "action-confirm-modal",
      "title": _vm.confirmData.title,
      "ok-variant": _vm.confirmData.variant,
      "ok-title": "YES",
      "cancel-title": "NO",
      "centered": "",
      "size": "sm"
    },
    on: {
      "ok": _vm.handleAction
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.confirmData.message))])]), _vm._v(" "), _c('b-modal', {
    ref: "view-job-details-modal",
    attrs: {
      "id": "view-job-details-modal",
      "title": "Job Summary & Documents",
      "size": "xl",
      "hide-footer": "",
      "centered": ""
    }
  }, [(_vm.selectedJob) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.selectedJob.fk_module_id,
      "JOBSERIES": _vm.selectedJob.jobNo
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1cb7416","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/payment/SlineApprovalList.vue
// module id = 2887
// module chunks = 0